export const light = {
  primary: '#262A2F',
  secondary: '#959A9F',
  third: '#BDC1C6',
  fourth: '#E2E5E7',
  fifth: '#F0F3F4',
  base: '#F9FAFB',
  background: '#FFFFFF',
};
